/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */
import { mergeMap } from './mergeMap';
export function concatMap(project, resultSelector) {
    return mergeMap(project, resultSelector, 1);
}
//# sourceMappingURL=concatMap.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/operators/concatMap.js
// module id = 775
// module chunks = 0